import Tooltip from 'components/Tooltip';
import moment from 'moment';
import React from 'react';

const AgingOutLastDate = ({
  lastDate,
  totalDays = 30,
  warningDaysDiff = 20,
  dangerDaysDiff = 10,
  tooltipTitle = 'Aging out',
  showTooltipOnWarningOrDanger = true,
}) => {
  const daysDiff =
    lastDate && lastDate.length > 0
      ? moment().diff(moment(lastDate), 'days')
      : 0;

  // Function to determine the CSS class based on the last checked-in date
  const getLastCheckedInStyle = () => {
    if (daysDiff) {
      if (daysDiff >= totalDays - dangerDaysDiff) {
        return 'text-danger font-weight-bold';
      } else if (daysDiff >= totalDays - warningDaysDiff) {
        return 'text-warning font-weight-bold';
      }
    }
    return '';
  };

  const getTooltipContent = () => {
    if (daysDiff >= 0) {
      const agingOut = totalDays - daysDiff; // Calculate the remaining days
      let title =
        agingOut < 0
          ? 'This asset will age out soon.'
          : `${tooltipTitle} in ${agingOut} days`;
      return title;
    }
    return '';
  };

  const dateElement = (
    <span className="p-2">
      {lastDate && lastDate.length > 0 ? moment(lastDate).format('lll') : ''}
    </span>
  );

  const shouldShowTooltip = () => {
    if (showTooltipOnWarningOrDanger) {
      return daysDiff >= totalDays - warningDaysDiff;
    }
    return true;
  };

  return (
    <div className={getLastCheckedInStyle()}>
      {shouldShowTooltip() ? (
        <Tooltip tooltip={getTooltipContent()}>{dateElement}</Tooltip>
      ) : (
        dateElement
      )}
    </div>
  );
};

export default AgingOutLastDate;
